// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles_gallery__nSybo","galleryContainer":"styles_galleryContainer__WWgfS","galleryItem":"styles_galleryItem__1ynu3","galleryCropped":"styles_galleryCropped__1oG5y"};